import React from "react";
import { Container } from "react-bootstrap";
import "./style.scss";
import placeholder from "../../../assets/images/placeholder-round.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialItem = ({ placeholder, comment, author }) => {
  return (
    <div className="testimonial__item">
      <div className="testimonial-author">
        <img src={placeholder} alt="testimonial" />
      </div>
      <div className="details">{comment}</div>
      <p className="author">{author}</p>
    </div>
  );
};
const generateText = (className, text) => {
  return <p className={className}>{text}</p>;
};
const Testimonials = ({ testimonials }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "5%",
        },
      },
    ],
  };
  return (
    <div className="testimonial__section">
      <Container>
        <h1 className="title">Testimonials</h1>
        <Slider {...settings}>
          {testimonials &&
            testimonials.map((item) => (
              <TestimonialItem key={item.id} {...item} />
            ))}
        </Slider>
      </Container>
    </div>
  );
};
Testimonials.defaultProps = {
  testimonials: [
    {
      id: 1,
      placeholder: placeholder,
      comment: generateText(
        "testimonial",
        "OpenStore brought a level of professionalism to the table that was a breath of fresh air and we look forward to working with everyone more in the near future!"
      ),
      author: "Ecommerce founder in the children’s apparel space",
    },
    {
      id: 2,
      placeholder: placeholder,
      author: "Ecommerce founder in the swimwear space",
      comment: generateText(
        "testimonial",
        `I think everything was great. It was very apparent that you guys had prepared well and were very professional. Really loved the tips you gave us even though no offer was made. It showed the
          diligence you all did looking into our data.`
      ),
    },
  ],
};
export default Testimonials;
